import { Observable } from 'rxjs';
import { PurchaseRequestDocumentUploadItemResult } from '../interfaces/purchase-request-document-upload-item-result';

export interface PurchaseRequestDocumentUploadPayload {
  purchaseId: string;
  supplierId: string;
  spreadsheetFile: File;
  supplierQuoteFile: File;
}

export abstract class AbstractPurchaseRequestDocumentService {
  abstract uploadDocuments(
    payload: PurchaseRequestDocumentUploadPayload
  ): Observable<PurchaseRequestDocumentUploadItemResult[]>;

  abstract downloadDocuments(purchaseId: string, supplierId: string): Observable<Blob>;
}
